import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Button, Row,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Moment from 'moment';
import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';
import SelectService from '../../../services/SelectService';
import ViewChequeModal from '../../../shared/modals/ViewChequeModal';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class CollectionReport extends Component {
   constructor() {
      super();
      this.state = {
         list: [],
         formdata: {
            locationId: '',
         },
         modal: false,
         totalCollections: 0,
         goTo: false,
         lastPageVisited: window.history.state !== null ? window.history.state.state.prevpage : '',
      };
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.searchTransaction = this.searchTransaction.bind(this);
      this.toggleModal = this.toggleModal.bind(this);
      this.paymentid = 0;
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadCollectionList();
   }

   loadCollectionList = async (inventoryFrom = '', inventoryTo = '', locationID = '') => {
      try {
         const dateFrom = inventoryFrom !== '' ? inventoryFrom : Moment(new Date()).format('YYYY-MM-DD');
         const dateTo = inventoryTo !== '' ? inventoryTo : Moment(new Date()).format('YYYY-MM-DD');
         const locID = locationID !== '' ? `/locationid/${locationID}` : '';

         const response = await CommonService.getRows(`collectionreport/inventoryfrom/${dateFrom}/inventoryto/${dateTo}${locID}`);
         if (response) {
            this.setState({ list: response.list, totalCollections: response.total_collection });
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   goBack = () => {
      this.setState({ goTo: true });
   }

   getLocations = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue, searchType: 9 };
      const options = [];
      if (this.isLoading) {
        await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.location_id,
                label: opt.location_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   handleChange = (e, fieldName) => {
      if (fieldName === 'fromDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           fromDate: date,
         },
       }));
     } else if (fieldName === 'inventoryFrom') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           inventoryFrom: date,
         },
       }));
     } else if (fieldName === 'inventoryTo') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           inventoryTo: date,
         },
       }));
     } else if (fieldName === 'locationid') {
         let locationId = '';
         if (e) {
            locationId = e.value;
         }

         this.setState(prevState => ({
           formdata: { ...prevState.formdata, locationId },
         }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   viewChequeDetails = (e, paymentID = '') => {
    e.preventDefault();
    this.paymentid = paymentID;
    this.toggleModal();
   }

   toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
   }

   searchTransaction(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const inventoryFrom = Moment(formdata.inventoryFrom).format('YYYY-MM-DD');
      const inventoryTo = Moment(formdata.inventoryTo).format('YYYY-MM-DD');
      this.loadCollectionList(inventoryFrom, inventoryTo, formdata.locationId);
   }

   render() {
      const {
         list, goTo, lastPageVisited, formdata, totalCollections, modal,
      } = this.state;

      if (goTo === true) {
         return <Redirect to={{ pathname: lastPageVisited }} />;
      }

      if (this.userdata.type !== '1') {
         return <Redirect to="/dashboard" />;
      }

      // to date
      let inventoryFrom = new Date();
      if (formdata.inventoryFrom) {
        inventoryFrom = new Date(formdata.inventoryFrom);
      }

      let inventoryTo = new Date();
      if (formdata.inventoryTo) {
        inventoryTo = new Date(formdata.inventoryTo);
      }

      return (
         <Col md={12}>
            <ViewChequeModal
                modal={modal}
                toggle={this.toggleModal}
                chequeid={this.paymentid}
            />
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">Collection Table</h5>
                     <div className="panel__btns">
                     {
                        lastPageVisited !== '' ? (
                           <Button onClick={this.goBack} className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" size="sm" outline>
                           <i className="fa fa-arrow-left" />
                           <span>Back</span>
                           </Button>
                        ) : ''
                     }
                     </div>
                  </div>
                  <Row className="m-0">
                     <Col md={12} className="m-b-20">
                        <form className="form form--horizontal the_form_display" onSubmit={this.searchTransaction}>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Location:</span>
                                 <div className="form__form-group-icon mh-38"><i className="fa fa-map-marker-alt" /></div>
                                 <AsyncSelect
                                    name="locationid"
                                    cacheOptions
                                    loadOptions={this.getLocations}
                                    defaultOptions
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Location name..."
                                    onChange={e => this.handleChange(e, 'locationid')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-40 xw-40">From:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="inventoryFrom"
                                    selected={inventoryFrom}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryFrom')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-30 xw-30">To:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="inventoryTo"
                                    selected={inventoryTo}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'inventoryTo')}
                                 />
                                 <button type="submit" className="form__form-group-button bg-primary">Search</button>
                              </div>
                           </div>
                        </form>
                     </Col>
                  </Row>
                  <div className="panel__content">
                  <h3>Total Collection: {totalCollections <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(totalCollections)}</span> : <span className="text-green">&#x20B1; {global.numberFormat(totalCollections)}</span>}</h3>
                  <Table responsive striped className="border-top">
                     <thead className="th-vtop">
                        <tr>
                           <th>Customer</th>
                           <th>Location</th>
                           <th>Amount</th>
                           <th>Date</th>
                           <th>Payment Type</th>
                           <th>Action</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           list.length > 0 ? list.map((item) => {
                            const collectionDate = Moment(item.date_added).format('MMMM DD, YYYY');
                                const CashAmount = global.parseToNumber(item.amount);

                                return (
                                 <tr key={item.payment_id} className="text-center">
                                    <td className="text-left">{item.customer_name}</td>
                                    <td className="text-left">{item.location_name}</td>
                                    <td className="text-left">&#x20b1; {global.numberFormat(CashAmount)}</td>
                                    <td className="text-left">{collectionDate}</td>
                                    <td className="text-left">{global.paymentType[item.payment_type]}</td>
                                    <td className="text-left">
                                        {
                                            (item.payment_type === '1') ? (
                                                <Button color="primary" className="btn-xs" onClick={e => this.viewChequeDetails(e, item.payment_id)} outline><span className="fa fa-eye" /></Button>
                                            ) : ''
                                        }
                                    </td>
                                 </tr>
                              );
                           }) : (
                              <tr className="text-center">
                                 <td colSpan="5">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(CollectionReport);
